module.exports = __webpack_public_path__ + "un-tenanted-deployment-logo.8ea431cf9cc0acc1ad26ca59cc16f376.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/components/DashboardDataSource/un-tenanted-deployment-logo.svg
// module id = 1565
// module chunks = 8